/**
 * Канонический URL страницы решения для SEO / GEO.
 * Предпочитаем /solutions/:vendorSlug/:solutionSlug; legacy — /product/:id.
 */
export function buildProductCanonicalPath(product, { vendorSlug, solutionSlug, catalogVendor } = {}) {
  const vSlug = (vendorSlug || catalogVendor?.slug || '').trim();
  const sSlug = (solutionSlug || product?.id || '').trim();
  if (vSlug && sSlug) {
    return `/solutions/${encodeURIComponent(vSlug)}/${encodeURIComponent(sSlug)}`;
  }
  if (product?.id) {
    return `/product/${encodeURIComponent(product.id)}`;
  }
  return '/solutions';
}

export function buildProductCanonicalUrl(baseUrl, product, options = {}) {
  const base = (baseUrl || 'https://antologia.tech').replace(/\/$/, '');
  return `${base}${buildProductCanonicalPath(product, options)}`;
}
